export const clientId = 'nprone_trial_md7V0Mrs4SIf';
export const secret = 'wKETaj71n42KtFHkF4XsliCM6vCHvCOcHFt24zk6';

export const stationUrl = 'https://api.npr.org/stationfinder/v3/stations'
export const authorizeUrl = 'https://api.npr.org/authorization/v2/token';

export const accessToken = '26ff4a92e255efe08a4fcb8247658db292e8846b888604a36470aa0b595b637af10a7a2f24c5b0e1';
export const refreshToken = '40572b83fb27058466c3edb7e293edf98c25b691eff69ad63562715072b332957adf66ffa3dd3689';



// WEBPACK FOOTER //
// ./src/util/constants.js